export default {
    "frames": [
        {
            "time": 0,
            "image": require("./sprite-ashe1.png")
        },
        {
            "time": 1 * 100,
            "image": require("./sprite-ashe2.png")
        },
        {
            "time": 2 * 100,
            "image": require("./sprite-ashe3.png")
        },
        {
            "time": 3 * 100,
            "image": require("./sprite-ashe4.png")
        },
        {
            "time": 4 * 100,
            "image": require("./sprite-ashe5.png")
        },
        {
            "time": 5 * 100,
            "image": require("./sprite-ashe6.png")
        },
        {
            "time": 6 * 100,
            "image": require("./sprite-ashe7.png")
        },
        {
            "time": 7 * 100,
            "image": require("./sprite-ashe8.png")
        },
        {
            "time": 8 * 100,
            "image": require("./sprite-ashe9.png")
        },
        {
            "time": 9 * 100,
            "image": require("./sprite-ashe10.png")
        },
        {
            "time": 10 * 100,
            "image": require("./sprite-ashe11.png")
        },
        {
            "time": 11 * 100,
            "image": require("./sprite-ashe12.png")
        },
        {
            "time": 12 * 100,
            "image": require("./sprite-ashe13.png")
        },
        {
            "time": 13 * 100,
            "image": require("./sprite-ashe14.png")
        },
        {
            "time": 14 * 100,
            "image": require("./sprite-ashe15.png")
        },
        {
            "time": 15 * 100,
            "image": require("./sprite-ashe16.png")
        },
        {
            "time": 16 * 100,
            "image": require("./sprite-ashe17.png")
        },
        {
            "time": 17 * 100,
            "image": require("./sprite-ashe18.png")
        },
        {
            "time": 18 * 100,
            "image": require("./sprite-ashe19.png")
        },
        {
            "time": 19 * 100,
            "image": require("./sprite-ashe20.png")
        },
        {
            "time": 20 * 100,
            "image": require("./sprite-ashe21.png")
        },
        {
            "time": 21 * 100,
            "image": require("./sprite-ashe22.png")
        },
    ]
}
